// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"41":"267cb63d","885":"10458a65"}[chunkId] + ".css";
};